import { useTranslation } from 'react-i18next'
import { Input } from 'antd'
import { useAppSelector, useAppDispatch } from 'store/hooks'
import { slices } from 'store/slices'
import { Title } from './styled'

const Inputs = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const translationPrefix = 'administration.blocks.type.questionBankV2.inputs'
  const data = useAppSelector(slices.questionBank.data)

  return (
    <>
      <Title $required>{t(`${translationPrefix}.name.title`)}</Title>
      <Input
        value={data.name}
        onChange={(e) => dispatch(slices.questionBank.setName(e.target.value))}
        placeholder={t(`${translationPrefix}.name.placeholder`)}
        autoFocus
      />
      <Title>{t(`${translationPrefix}.description.title`)}</Title>
      <Input.TextArea
        value={data.description}
        onChange={(e) =>
          dispatch(slices.questionBank.setDescription(e.target.value))
        }
        placeholder={t(`${translationPrefix}.description.placeholder`)}
        autoSize={{ minRows: 4, maxRows: 4 }}
      />
    </>
  )
}

export default Inputs
